import i18n from '../../i18n';

// Shared helpers and label getters resolve the current language at call time.
// Components subscribe to language changes with useTranslation('tasks').
export const traduzirTarefas = (key, options = {}) => i18n.t(key, { ns: 'tasks', ...options });

export const idiomaTarefas = () => ({
  pt: 'pt-BR', en: 'en', es: 'es', de: 'de', fr: 'fr', it: 'it', zh: 'zh-CN'
}[String(i18n.resolvedLanguage || i18n.language || 'pt').split('-')[0]] || 'pt-BR');

// The API currently returns Portuguese messages. Translate known messages here
// without changing its contracts or interpolating user-authored content.
export const traduzirErroTarefas = (message, fallback) => {
  if (typeof message !== 'string' || !message) return fallback;
  const catalog = i18n.getResourceBundle('pt', 'tasks') || {};
  const errors = { ...catalog.errors, activeTimerExists: catalog.activeTimerExists };
  for (const [key, text] of Object.entries(errors)) {
    if (!text) continue;
    const translationKey = key === 'activeTimerExists' ? key : `errors.${key}`;
    if (text === message) return traduzirTarefas(translationKey);
    if (text.includes('{{count}}')) {
      const [before, after] = text.split('{{count}}');
      if (!message.startsWith(before) || !message.endsWith(after)) continue;
      const value = message.slice(before.length, message.length - after.length);
      if (/^\d+$/.test(value)) return traduzirTarefas(translationKey, { count: Number(value) });
    }
  }
  return idiomaTarefas() === 'pt-BR' ? message : fallback;
};
